import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

import FilterBox from '../common/FilterBox';
import FilterDropdown from '../common/FilterDropdown';
const KeyboardUtil = require("../../util/keyboard");
const _ = {
    forEach: require('lodash/forEach'),
};

const propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    currentPage: PropTypes.number.isRequired,
    numPages: PropTypes.number.isRequired,
    anySearchTerms: PropTypes.bool.isRequired,
    searchTermsApplied: PropTypes.bool.isRequired,
    filterPages: PropTypes.number.isRequired,
    totalRecords: PropTypes.number.isRequired,
    requestPage: PropTypes.func.isRequired,
    searchTerms: PropTypes.object.isRequired,
    hideSearch: PropTypes.bool,
    onFilterChange: PropTypes.func.isRequired,
    doApplySearchTerms: PropTypes.func.isRequired,
};

const defaultProps = {
    className: '',
    hideSearch: false,
};


function MultiFilterPaginationControls(props) {
    function onFilterKeyDown(e) {
        if (KeyboardUtil.isEnterKey(e.keyCode)) {
            props.doApplySearchTerms()
        }
    }

    const overallNumPages = props.numPages;
    const currentNumPages = props.filterPages;
    const hasMultipleRecords = (props.totalRecords > 1);
    const hasMultiplePages = (currentNumPages > 1);
    let pageButtons;

    if (!hasMultiplePages || !hasMultipleRecords) {
        pageButtons = null;
    }
    else if (hasMultiplePages) { // show 10 page numbers at a time
        pageButtons = [];
        const firstPage = Math.max(1, props.currentPage - 4);
        const lastPage = Math.min(firstPage + 9, currentNumPages);
        const pageSet = Math.ceil(props.currentPage / 10);
        const prevSetPage = (pageSet - 1) * 10 - 5;
        const nextSetPage = (pageSet + 1) * 10 - 5;
        
        if (firstPage > 1) {
            pageButtons.push(
                <Button key={1} onClick={props.requestPage.bind(null, 1)}>
                    {'|<'}
                </Button>
            );
        }
        
        if (prevSetPage > 1) {
            pageButtons.push(
                <Button key={prevSetPage} onClick={props.requestPage.bind(null, prevSetPage)}>
                    {'<<'}
                </Button>
            );
        }
        
        for (let page = firstPage; page <= lastPage; ++page) {
            if (page === props.currentPage) {
                pageButtons.push(
                    <Button key={page} className="current-page" disabled>
                        {page}
                    </Button>
                );
            }
            else {
                const pageFunc = props.requestPage.bind(null, page);
                // () => { props.requestPage(page); } <---- doesn't work (uses the value of page after the end of the loop???
                pageButtons.push(
                    <Button key={page} onClick={pageFunc}>
                        {page}
                    </Button>
                );
            }
        }
        
        if (nextSetPage < currentNumPages) {
            pageButtons.push(
                <Button key={nextSetPage} onClick={props.requestPage.bind(null, nextSetPage)}>
                    {'>>'}
                </Button>
            );
        }
        
        if (lastPage < currentNumPages) {
            pageButtons.push(
                <Button key={currentNumPages} onClick={props.requestPage.bind(null, currentNumPages)}>
                    {'>|'}
                </Button>
            );
        }
    }

    let searchButton = null;
    let filterBoxes = [];
    let searchEnabled = !props.searchTermsApplied;
    if (hasMultipleRecords) {
        searchButton = (
            <button
                className="bare-text-button glyph"
                disabled={!searchEnabled}
                onClick={()=>{ props.doApplySearchTerms() }}
            >
                <i className={"fa fa-search" + (props.searchTermsApplied ? " disabled": "")} aria-hidden />
                <span className="sr-only">Filter</span>
            </button>
        );

        _.forEach(props.searchTerms,(entry,key)=>{
            filterBoxes.push(
                <div className="paginationRow__filter" key={key}>
                    {entry.options ? 
                    <FilterDropdown
                        inputId={`${props.id}-filter-${key}`}
                        className="pagination-filter margin-bottom-md margin-right-md"
                        icon="fa fa-font"
                        label={entry.name}
                        options={entry.options}
                        onChange={(value,id)=>{props.onFilterChange(key,value,id)}}
                        value={entry.searchTerm}
                    />
                    :
                    <FilterBox
                        inputId={`${props.id}-filter-${key}`}
                        className="pagination-filter margin-bottom-md margin-right-md"
                        icon="fa fa-font"
                        label={entry.name}
                        onKeyDown={searchEnabled ? onFilterKeyDown : null}
                        onChange={(e)=>{props.onFilterChange(key,e.target.value)}}
                        value={entry.searchTerm}
                    />
                    }
                </div>
            );
        })
        
    }

    return (
        <div id={props.id} className={`paginationRow ${props.className}`}>
            {(hasMultipleRecords && !props.hideSearch) ? filterBoxes : null }
            {(hasMultipleRecords && !props.hideSearch) ? searchButton : null}
            <div className="paginationRow__pageButtons">
                {pageButtons}
            </div>
        </div>
    );
}

MultiFilterPaginationControls.propTypes = propTypes;
MultiFilterPaginationControls.defaultProps = defaultProps;

export default MultiFilterPaginationControls;